/* global angular, moment */
/**
 * Created by lari on 01/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('clienteditor', {
      restrict: 'E',
      bindings: {
        client: '<?',
        clientid: '@?',
        parentsave: '&?',
        mode: '@?',
        clientcategories: '<?'
      },
      templateUrl: 'vcclient/clienteditor-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'ClientHelper', 'vertxEventBusService', '$window', '$timeout',
        function ($log, Rlog, ClientHelper, vertxEventBusService, $window, $timeout) {
          let vm = this;
          vm.title = 'clienteditor-component-controller';
          vm.save = save;
          vm.addContact = addContact;
          vm.childsave = function () {
            $log.debug('debug: clienteditor childsave called');
            return vm.save();
          };
          vm.savesave = savesave;

          vm.$onInit = function () {
            if (angular.isDefined(vm.mode) && vm.mode === 'patient') {
              vm.kunde = 'Patient';
              vm.testkunde = 'Testpatient';
            } else {
              vm.mode = 'client';
              vm.kunde = 'Kunde';
              vm.testkunde = 'Testkunde';
            }

            if (angular.isDefined(vm.client) && vm.client.hasOwnProperty('_id')) {
              if (angular.isUndefined(vm.client.contacts)) {
                vm.client.contacts = [];
              }

              if (angular.isUndefined(vm.client.companydata)) {
                vm.client.companydata = {};
              }

              if (vm.mode === 'patient' && angular.isUndefined(vm.client.svdata)) {
                vm.client.svdata = {};
              }

              vm.lastclient = angular.copy(vm.client);
              vm.save();
            }

            if (angular.isDefined(vm.clientid) && angular.isDefined(vm.clientid.length) && vm.clientid.length > 0) {
              ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
                vm.client = client;
                if (angular.isUndefined(vm.client.contacts)) {
                  vm.client.contacts = [];
                }

                if (angular.isUndefined(vm.client.companydata)) {
                  vm.client.companydata = {};
                }

                if (vm.mode === 'patient' && angular.isUndefined(vm.client.svdata)) {
                  vm.client.svdata = {};
                }

                vm.lastclient = angular.copy(vm.client);
                vm.save();
              });
            }


            // dead code? Load client/patient from backend if no client object but a clientid was provided
            // ran into problems with un-initialised sub-widgets -> load client object in router
            /*            if (angular.isDefined(vm.client) && angular.isObject(vm.client) && vm.client.hasOwnProperty('_id')) {
                          vm.lastclient = angular.copy(vm.client);
                          makesane();
                          vm.workingclient = angular.copy(vm.client);
                        }
                        else if (angular.isDefined(vm.clientid) && angular.isString(vm.clientid) && vm.clientid.length > 0) {
                          ClientHelper.find(vm.mode, vm.clientid).$then((client) => {
                            vm.client = client;
                            $log.debug('debug: client retrieved my restmod: ', vm.client);
                            makesane();
                            vm.workingclient = angular.copy(vm.client);
                            vm.lastclient = angular.copy(vm.client);
                            $log.debug('debug: workingclient copy', vm.workingclient);
                          }, (error) => {
                            vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
                            Rlog.error('client', 'clienteditor', 'client.$find() failed', {id: vm.clientid});
                          });
                        }
                        else {
                          $log.debug('debug: client editor - neither client nor clientid was provided');
                          vm.error = 'Es wurde weder ein ' + vm.kunde + 'n Objekt noch eine Identifikationsnummer übergeben. Es sind keine Daten vorhanden. Der Fehler wurde protokolliert.!';
                          Rlog.error('client', 'clienteditor', 'neither client nor clientid was provided', {});
                        }*/
          }; // $onInit()

          function addContact() {
            // $log.debug('debug: addContact called');
            if (angular.isUndefined(vm.client.contacts)) {
              vm.client.contacts = [];
            }
            vm.client.contacts.push({});
          }

          function save() {
            if (!angular.equals(vm.client, vm.lastclient)) {
              vm.lastclient = angular.copy(vm.client);
              if (vm.client.$hasPendingActions) {
                vm.client.$cancel();
                $timeout(function () {
                  $log.warn('[CLIENT][ClientEditor] waited 1.5 seconds because of file having had pending actions, saving now.');
                  vm.savesave();
                }, 1500);
              } else {
                vm.savesave();
              }
            }
          }

          function savesave() {
            // $log.debug('debug: savesave vm.client: ', vm.client.svdata);
            if (angular.isDefined(vm.client.$save)) {
              vm.client.$save().$then(function () {
              }, function () {
                $log.debug('debug/error: client save failed!');
                Rlog.error('client', 'clienteditor', 'client.$save() failed', {id: vm.client._id});
              });
            } else {
              $log.debug('debug/error: client $save not defined!');
            }
          }

          const patientsUpdateHandler = function (message) {
            $log.debug('debug: Patient update received: ', message);
            let messages = message.split(':');
            // $log.debug('debug: $tabid: ', $window.sessionStorage.getItem('sprtabid'));
            if (angular.isDefined(vm.client) && angular.isDefined(vm.client._id)) {
              if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
                vm.client.$refresh().$then(function () {
                  $log.debug('debug: clienteditor refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
                }, function (error) {
                  $log.debug('debug: clienteditor could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
                });
              }
            }

          };

          const clientsUpdateHandler = function (message) {
            $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.client) && angular.isDefined(vm.client._id)) {
              if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
                vm.client.$refresh().$then(function () {
                  $log.debug('debug: clienteditor refreshed client: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
                }, function (error) {
                  $log.debug('debug: clienteditor could not refresh client: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
                });
              }
            }
          };


          vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
          vertxEventBusService.on('clients.update', {}, clientsUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
            vertxEventBusService.unregisterHandler('clients.update', {}, clientsUpdateHandler);
          };


          // GUI info & help texts
          vm.clientcathelp = 'Kunden können in beliebige Kategorien gruppiert werden. Die Kategorien können entweder frei gewält werden oder als Auswahlliste im Zahnradmenü unter ´Einstellungen´ angelegt werden';
          if (vm.mode === 'patient') {
            vm.testhelp = 'Mit Testpatienten können Sie alle Funktionen, einschließlich Rechnungslegung, ausprobieren, ohne sich das Stornieren von Rechnungen kümmern zu müssen. Alle Rechnungen die Sie auf Testpatienten ausstellen werden automatisch als Test gekennzeichnet und gleich wieder storniert';
          } else {
            vm.testhelp = 'Mit Testkunden können Sie alle Funktionen, einschließlich Rechnungslegung, ausprobieren, ohne sich das Stornieren von Rechnungen kümmern zu müssen. Alle Rechnungen die Sie auf Testkunden ausstellen werden automatisch als Test gekennzeichnet und gleich wieder storniert';
          }

        }] // controller
    }); // component

// klammerfriedhof
}());